import { jsx as _jsx } from "react/jsx-runtime";
import { Stack, Text } from '@fluentui/react';
import * as React from 'react';
function executeScroll(ref) {
    ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}
export const SitemapNavBar = ({ titles = [], refs = null })=>{
    return /*#__PURE__*/ _jsx(Stack, {
        horizontal: true,
        wrap: true,
        className: "sitemap_nav",
        children: titles.map((title)=>/*#__PURE__*/ _jsx(Text, {
                role: "link",
                "aria-label": `${title} link`,
                className: "sitemap_nav_item",
                onClick: ()=>executeScroll(refs[`${title}`]),
                children: title
            }, title))
    });
};
